import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Loading() {
  return (
    <div className="min-h-screen grid place-items-center">
      <div className="flex flex-col items-center gap-3">
        <div className="h-10 w-10 rounded-full border-2 border-emerald-500 border-t-transparent animate-spin" />
        <p className="text-sm text-slate-500">Loading your AccessWealth…</p>
      </div>
    </div>
  );
}

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, bootstrapped, activeClient } = useAuth();
  if (!bootstrapped) return <Loading />;
  if (!user || user === false || !user.id)
    return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin")
    return <Navigate to="/dashboard" replace />;

  // A Personal Finance Advisor has no personal wealth dashboard. They reach the
  // normal modules only while viewing a specific client; otherwise send them to
  // their workspace.
  if (user.role === "pfa" && !adminOnly && !activeClient)
    return <Navigate to="/advisor" replace />;

  return children;
}

// Guards the advisor workspace (/advisor/*). Approved PFAs only.
export function AdvisorRoute({ children }) {
  const { user, bootstrapped } = useAuth();
  if (!bootstrapped) return <Loading />;
  if (!user || user === false || !user.id)
    return <Navigate to="/login" replace />;
  if (user.role !== "pfa") return <Navigate to="/dashboard" replace />;
  return children;
}
